import { render } from "./AdministratorOneQuestionContent.vue?vue&type=template&id=6f012714&scoped=true"
import script from "./AdministratorOneQuestionContent.vue?vue&type=script&lang=js"
export * from "./AdministratorOneQuestionContent.vue?vue&type=script&lang=js"

import "./AdministratorOneQuestionContent.vue?vue&type=style&index=0&id=6f012714&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f012714"]])

export default __exports__